/**
 * Custom Discount Manager
 * Gerencia descontos personalizados configurados no tema
 */
class CustomDiscountManager {
  constructor() {
    
    this.discountSettings = {
      enabled: window.themeSettings?.customDiscount?.enabled || false,
      percentage: window.themeSettings?.customDiscount?.percentage || 10,
      label: window.themeSettings?.customDiscount?.label || '',
      color: window.themeSettings?.customDiscount?.color || '#ff4800',
      background: window.themeSettings?.customDiscount?.background || '#fff2e6',
      scope: window.themeSettings?.customDiscount?.scope || 'all',
      collections: window.themeSettings?.customDiscount?.collections || [],
      allCollections: window.themeSettings?.customDiscount?.allCollections || false,
      excludedCollections: window.themeSettings?.customDiscount?.excludedCollections || ''
    };
    
    this.init();
  }

  init() {
    if (!this.discountSettings.enabled) {
      return;
    }
    
    
    // Aguardar um pouco para garantir que todos os elementos estejam carregados
    setTimeout(() => {
      this.updateAllPrices();
      this.observePriceChanges();
      this.setupVariantChangeListener();
    }, 500);

    // Verificação adicional para garantir que a variante inicial seja aplicada
    setTimeout(() => {
      this.updateInitialVariantPrice();
    }, 1000);

    // Verificação específica para prateleira
    setTimeout(() => {
      this.updateShelfPrices();
    }, 1500);
  }


  /**
   * Atualiza todos os preços na página
   */
  updateAllPrices() {
    const priceElements = document.querySelectorAll('.price:not(.custom-discount-applied)');
    const customDiscountElements = document.querySelectorAll('.custom-discount');
    
    
    priceElements.forEach(priceElement => {
      if (priceElement.classList.contains('price--sale-box')) return;
      this.updatePriceElement(priceElement);
    });

    // Verificar se há variante selecionada inicialmente e atualizar desconto personalizado
    this.updateInitialVariantPrice();
  }

  /**
   * Atualiza preço inicial baseado na variante selecionada ou primeira disponível
   */
  updateInitialVariantPrice() {
    
    // Buscar variante selecionada inicialmente (para PDP)
    const variantInput = document.querySelector('.product-variant-id');
    let currentVariantId = null;
    
    if (variantInput && variantInput.value) {
      currentVariantId = variantInput.value;
    } else {
    }

    // Buscar elementos de desconto personalizado
    const customDiscountElements = document.querySelectorAll('.custom-discount');

    customDiscountElements.forEach(element => {
      const variantsData = element.dataset.productVariants;
      if (variantsData) {
        try {
          const variants = JSON.parse(variantsData);
          let targetVariant = null;
          
          if (currentVariantId) {
            // Na PDP: usar variante selecionada
            targetVariant = variants.find(v => v.id.toString() === currentVariantId);
          } else {
            // Na prateleira: usar primeira variante disponível
            targetVariant = variants.find(v => v.available) || variants[0];
          }
          
          if (targetVariant) {
            this.updateCustomDiscountForVariant(element, targetVariant);
          } else {
          }
        } catch (error) {
        }
      }
    });
  }

  /**
   * Atualiza preços específicos para prateleira/coleção
   */
  updateShelfPrices() {
    
    // Verificar se estamos em uma página de prateleira (sem variante selecionada)
    const variantInput = document.querySelector('.product-variant-id');
    if (variantInput && variantInput.value) {
      return;
    }

    // Buscar todos os elementos de desconto personalizado na página
    const customDiscountElements = document.querySelectorAll('.custom-discount');

    customDiscountElements.forEach(element => {
      const variantsData = element.dataset.productVariants;
      const priceVaries = element.dataset.priceVaries === 'true';
      
      if (variantsData && priceVaries) {
        try {
          const variants = JSON.parse(variantsData);
          // Usar primeira variante disponível ou primeira variante
          const targetVariant = variants.find(v => v.available) || variants[0];
          
          if (targetVariant) {
            this.updateCustomDiscountForVariant(element, targetVariant);
          }
        } catch (error) {
        }
      }
    });
  }

  /**
   * Verifica se o produto pertence às coleções selecionadas
   */
  isProductInSelectedCollections(productElement) {
    if (this.discountSettings.scope === 'all') {
      // Verificar se o produto está em coleção excluída
      if (this.discountSettings.excludedCollections) {
        const excludedHandles = this.discountSettings.excludedCollections.split(',').map(h => h.trim());
        const productHandle = productElement.closest('[data-product-handle]')?.dataset.productHandle;
        
        if (productHandle && excludedHandles.includes(productHandle)) {
          return false;
        }
      }
      return true;
    }
    if (this.discountSettings.scope !== 'collections') return false;

    // Se "aplicar em todas as coleções" está ativado
    if (this.discountSettings.allCollections) {
      // Verificar se o produto está em coleção excluída
      if (this.discountSettings.excludedCollections) {
        const excludedHandles = this.discountSettings.excludedCollections.split(',').map(h => h.trim());
        const productHandle = productElement.closest('[data-product-handle]')?.dataset.productHandle;
        
        if (productHandle && excludedHandles.includes(productHandle)) {
          return false;
        }
      }
      return true;
    }

    // Verificar coleções específicas
    if (!this.discountSettings.collections || this.discountSettings.collections.length === 0) return false;

    // Tentar obter informações do produto do elemento
    const productHandle = productElement.closest('[data-product-handle]')?.dataset.productHandle;
    const productId = productElement.closest('[data-product-id]')?.dataset.productId;
    
    // Se não conseguimos identificar o produto, aplicamos por segurança
    if (!productHandle && !productId) return true;

    // Verificar se o produto está em alguma das coleções selecionadas
    // Esta verificação será feita principalmente no lado do servidor (Liquid)
    // Aqui apenas como fallback
    return true;
  }

  /**
   * Atualiza um elemento de preço específico
   */
  updatePriceElement(priceElement) {
    if (priceElement.classList.contains('custom-discount-applied')) return;
     
    // Verificar se já tem desconto nativo
    const hasNativeDiscount = priceElement.classList.contains('price--on-sale');
    if (hasNativeDiscount) return;

    // IMPORTANTE: Não aplicar desconto via JS quando há lógica de exclusão de coleções
    // O Liquid já faz a verificação correta das coleções excluídas
    // O JS só deve atualizar preços quando há mudança de variante
    if (this.discountSettings.excludedCollections && this.discountSettings.excludedCollections.trim() !== '') {
      // Se há coleções excluídas configuradas, não aplicar desconto automaticamente
      // O Liquid já cuidou disso
      return;
    }

    // Verificar se o produto pertence às coleções selecionadas
    if (!this.isProductInSelectedCollections(priceElement)) return;

    // Verificar se é um preço que varia (price-varies)
    if (priceElement.classList.contains('product__price-varies')) {
      this.updateVariesPriceElement(priceElement);
      return;
    }

    // Buscar por diferentes tipos de elementos de preço
    let originalPriceElement = priceElement.querySelector('.price-item--regular');
    
    if (!originalPriceElement) {
      originalPriceElement = priceElement.querySelector('.price__regular');
    }
    if (!originalPriceElement) {
      originalPriceElement = priceElement.querySelector('.price-item--sale');
    }
    if (!originalPriceElement) {
      originalPriceElement = priceElement.querySelector('.price-item--sale-in-card');
    }
    if (!originalPriceElement) {
      originalPriceElement = priceElement.querySelector('.price__sale');
    }
    if (!originalPriceElement) {
      originalPriceElement = priceElement.querySelector('.price__current');
    }
    if (!originalPriceElement) {
      originalPriceElement = priceElement.querySelector('.price-item');
    }
    
    if (!originalPriceElement) return;

    const originalPriceText = originalPriceElement.textContent.trim();
    const originalPrice = this.parsePrice(originalPriceText);
     
    if (isNaN(originalPrice)) {
      return;
    }

    const discountedPrice = this.calculateDiscountedPrice(originalPrice);
    const formattedOriginalPrice = this.formatPrice(originalPrice);
    const formattedDiscountedPrice = this.formatPrice(discountedPrice);

    // Criar elemento de desconto personalizado
    const customDiscountElement = this.createCustomDiscountElement(
      formattedOriginalPrice,
      formattedDiscountedPrice
    );

    // Substituir o preço original pelo desconto personalizado
    priceElement.innerHTML = '';
    priceElement.appendChild(customDiscountElement);
    priceElement.classList.add('custom-discount-applied');
  }

  /**
   * Atualiza elemento de preço que varia (price-varies)
   */
  updateVariesPriceElement(priceElement) {
    // Extrair preços do texto "De R$ X até R$ Y"
    const priceText = priceElement.textContent.trim();
    
    // Regex para extrair preços do formato "De R$ X até R$ Y"
    const priceMatch = priceText.match(/De\s+R\$\s*([\d.,]+)\s+até\s+R\$\s*([\d.,]+)/i);
    
    if (!priceMatch) return;
    
    const priceFrom = this.parsePrice(priceMatch[1]);
    const priceTo = this.parsePrice(priceMatch[2]);
    
    if (isNaN(priceFrom) || isNaN(priceTo)) return;
    
    // Calcular desconto para ambos os preços
    const discountedPriceFrom = this.calculateDiscountedPrice(priceFrom);
    const discountedPriceTo = this.calculateDiscountedPrice(priceTo);
    
    const formattedPriceFrom = this.formatPrice(priceFrom);
    const formattedPriceTo = this.formatPrice(priceTo);
    const formattedDiscountedFrom = this.formatPrice(discountedPriceFrom);
    const formattedDiscountedTo = this.formatPrice(discountedPriceTo);
    
    // Criar elemento de desconto personalizado para preços que variam
    const customDiscountElement = this.createVariesDiscountElement(
      formattedPriceFrom,
      formattedPriceTo,
      formattedDiscountedFrom,
      formattedDiscountedTo
    );
    
    // Substituir o preço original pelo desconto personalizado
    priceElement.innerHTML = '';
    priceElement.appendChild(customDiscountElement);
    priceElement.classList.add('custom-discount-applied');
  }

  createCustomDiscountElement(originalPriceText, discountedPriceText) {
    const container = document.createElement('div');
    container.className = 'custom-discount__container';
    container.style.setProperty('--discount-color', this.discountSettings.color);
    container.style.setProperty('--discount-background', this.discountSettings.background);

    // Calcular o valor numérico do preço com desconto para o parcelamento
    const discountedPrice = this.parsePrice(discountedPriceText);

    container.innerHTML = `
      <div class="custom-discount__regular">
        <span class="custom-discount__original-price">
          De: <s>${originalPriceText}</s>
        </span>
        <span class="custom-discount__discounted-price">
          Por: ${discountedPriceText}
          ${this.discountSettings.label ? `<span class="custom-discount__label">${this.discountSettings.label}</span>` : ''}
          
          <span class="parcelado" style="margin-top: 3px;">
            ${this.generateInstallmentText(discountedPrice)}
          </span>
        </span>
        <span class="custom-discount__badge">
          -${this.discountSettings.percentage}%
        </span>
      </div>
    `;

    return container;
  }

  /**
   * Cria elemento de desconto para preços que variam
   */
  createVariesDiscountElement(priceFrom, priceTo, discountedFrom, discountedTo) {
    const container = document.createElement('div');
    container.className = 'custom-discount__container';
    container.style.setProperty('--discount-color', this.discountSettings.color);
    container.style.setProperty('--discount-background', this.discountSettings.background);

    // Calcular o valor numérico do preço com desconto para o parcelamento (usar o menor preço)
    const discountedPrice = this.parsePrice(discountedFrom);

    container.innerHTML = `
      <div class="custom-discount__regular">
        <span class="custom-discount__original-price">
          De: <s>${priceFrom}</s> até <s>${priceTo}</s>
        </span>
        <span class="custom-discount__discounted-price">
          Por: ${discountedFrom} até ${discountedTo}
          ${this.discountSettings.label ? `<span class="custom-discount__label">${this.discountSettings.label}</span>` : ''}
          
          <span class="parcelado" style="margin-top: 3px;">
            ${this.generateInstallmentText(discountedPrice)}
          </span>
        </span>
        <span class="custom-discount__badge">
          -${this.discountSettings.percentage}%
        </span>
      </div>
    `;

    return container;
  }

  /**
   * Calcula o preço com desconto
   */
  calculateDiscountedPrice(originalPrice) {
    const discountAmount = originalPrice * (this.discountSettings.percentage / 100);
    return originalPrice - discountAmount;
  }

  /**
   * Converte texto de preço para número
   */
  parsePrice(priceText) {
    if (!priceText) return NaN;
    
    // Remove R$, espaços e converte vírgula para ponto
    const cleaned = priceText.replace(/R\$\s?/, '').replace(/\./g, '').replace(',', '.').trim();
    
    const parsed = parseFloat(cleaned);
    
    return parsed;
  }

  /**
   * Formata número para formato de preço brasileiro
   */
  formatPrice(price) {
    // Detectar se o preço está em centavos ou reais
    // O Shopify sempre retorna preços em centavos (variant.price)
    // Após cálculos de desconto, o valor permanece em centavos
    // Se o valor é >= 100, assumimos que está em centavos e dividimos por 100
    // Se o valor é < 100, já está em reais (ex: parseado de texto "R$ 4,19")
    const priceInReais = price >= 100 ? price / 100 : price;
    
    return priceInReais.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  /**
   * Gera o texto de parcelamento baseado no valor
   * @param {number} price - O preço (em centavos ou reais)
   * @param {boolean} isInCents - Se true, o preço já está em centavos. Se false ou undefined, está em reais.
   */
  generateInstallmentText(price, isInCents = false) {
    // Converter para centavos se necessário
    let valor;
    
    if (isInCents) {
      // Já está em centavos (vem direto de variant.price)
      valor = Math.round(price);
    } else {
      // Está em reais (foi parseado de texto formatado), converter para centavos
      valor = Math.round(price * 100);
    }
    
    let installments = 1;
    
    // Tabela de parcelamento: começa em R$ 100 (1x) e a cada R$ 50 adiciona 1 parcela, até 12x
    if (valor <= 10000) {
      // Até R$ 100: 1x
      installments = 1;
    } else if (valor <= 15000) {
      // R$ 100-150: 2x
      installments = 2;
    } else if (valor <= 20000) {
      // R$ 150-200: 3x
      installments = 3;
    } else if (valor <= 25000) {
      // R$ 200-250: 4x
      installments = 4;
    } else if (valor <= 30000) {
      // R$ 250-300: 5x
      installments = 5;
    } else if (valor <= 35000) {
      // R$ 300-350: 6x
      installments = 6;
    } else if (valor <= 40000) {
      // R$ 350-400: 7x
      installments = 7;
    } else if (valor <= 45000) {
      // R$ 400-450: 8x
      installments = 8;
    } else if (valor <= 50000) {
      // R$ 450-500: 9x
      installments = 9;
    } else if (valor <= 55000) {
      // R$ 500-550: 10x
      installments = 10;
    } else if (valor <= 60000) {
      // R$ 550-600: 11x
      installments = 11;
    } else {
      // Acima de R$ 600: 12x
      installments = 12;
    }
    
    const installmentValue = valor / installments;
    const formattedInstallment = this.formatPrice(installmentValue);
    const formattedTotal = this.formatPrice(valor);
    
    return `<div class="price-installments-variants">${installments}x <span>${formattedInstallment}</span> sem juros (${formattedTotal})</div>`;
  }

  /**
   * Observa mudanças nos preços (para produtos com variantes)
   */
  observePriceChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const priceElements = node.querySelectorAll ? 
                node.querySelectorAll('.price:not(.custom-discount-applied)') : 
                (node.classList && node.classList.contains('price') && !node.classList.contains('custom-discount-applied') ? [node] : []);
              
              priceElements.forEach(priceElement => {
                this.updatePriceElement(priceElement);
              });
            }
          });
        }
      });
    });

    // Observar mudanças no DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Configura listener para mudanças de variantes
   */
  setupVariantChangeListener() {
    // Escutar mudanças de variantes
    document.addEventListener('afterVariantChanged', (event) => {
      this.handleVariantChange(event.detail);
    });

    // Também escutar mudanças de opções de variantes
    document.addEventListener('optionValueSelectionChange', (event) => {
      
      // Aguardar um pouco para que a variante seja atualizada
      setTimeout(() => {
        // Tentar obter a variante atual do produto
        const productInfo = document.querySelector('product-info');
        if (productInfo && productInfo.dataset.section) {
          const variantInput = productInfo.querySelector('.product-variant-id');
          if (variantInput && variantInput.value) {
            
            // Buscar informações da variante nos dados do produto
            const customDiscountElements = document.querySelectorAll('.custom-discount');
            
            customDiscountElements.forEach(element => {
              const variantsData = element.dataset.productVariants;
              if (variantsData) {
                try {
                  const variants = JSON.parse(variantsData);
                  const variant = variants.find(v => v.id.toString() === variantInput.value);
                  if (variant) {
                    this.updateCustomDiscountForVariant(element, variant);
                  } else {
                  }
                } catch (e) {
                }
              } else {
              }
            });
          } else {
          }
        } else {
        }
      }, 200);
    });
  }

  /**
   * Manipula mudança de variante
   */
  handleVariantChange(variantData) {
    const { variant, sectionId } = variantData;
    if (!variant) return;


    // Buscar elementos de desconto personalizado - tentar diferentes seletores
    let customDiscountElements = document.querySelectorAll(`.custom-discount[data-product-id="${variant.product_id}"]`);
    
    // Se não encontrar por product_id, buscar todos os elementos de desconto
    if (customDiscountElements.length === 0) {
      customDiscountElements = document.querySelectorAll('.custom-discount');
    }
    
    
    customDiscountElements.forEach(element => {
      this.updateCustomDiscountForVariant(element, variant);
    });
  }

  /**
   * Atualiza desconto personalizado para uma variante específica
   */
  updateCustomDiscountForVariant(element, variant) {
    const discountPercentage = parseFloat(element.dataset.discountPercentage) || this.discountSettings.percentage;
    const discountLabel = element.dataset.discountLabel || this.discountSettings.label;
    const priceVaries = element.dataset.priceVaries === 'true';
    
    
    if (priceVaries) {
      // Para produtos com preços que variam, usar o preço da variante selecionada
      this.updateVariesDiscountForVariant(element, variant, discountPercentage, discountLabel);
    } else {
      // Para produtos com preço fixo
      this.updateFixedDiscountForVariant(element, variant, discountPercentage, discountLabel);
    }
  }

  /**
   * Atualiza desconto para variante com preços que variam
   */
  updateVariesDiscountForVariant(element, variant, discountPercentage, discountLabel) {
    const originalPrice = variant.price;
    const discountAmount = originalPrice * (discountPercentage / 100);
    const discountedPrice = originalPrice - discountAmount;

    const formattedOriginalPrice = this.formatPrice(originalPrice);
    const formattedDiscountedPrice = this.formatPrice(discountedPrice);

    const container = element.querySelector('.custom-discount__container');
    
    if (container) {
      // Verificar o HTML atual antes da atualização
      
      const newHTML = `
        <div class="custom-discount__regular">
          <span class="custom-discount__original-price">
            De: <s>${formattedOriginalPrice}</s>
          </span>
          <span class="custom-discount__discounted-price">
            Por: ${formattedDiscountedPrice}
            ${discountLabel ? `<span class="custom-discount__label">${discountLabel}</span>` : ''}
            
            <span class="parcelado" style="margin-top: 3px;">
              ${this.generateInstallmentText(discountedPrice, true)}
            </span>
          </span>
        </div>
      `;
      
      container.innerHTML = newHTML;
      
      // Verificar o HTML após a atualização
      
      // Forçar reflow para garantir que a mudança seja visível
      container.offsetHeight;
    } else {
    }
  }

  /**
   * Atualiza desconto para variante com preço fixo
   */
  updateFixedDiscountForVariant(element, variant, discountPercentage, discountLabel) {
    const originalPrice = variant.price;
    const discountAmount = originalPrice * (discountPercentage / 100);
    const discountedPrice = originalPrice - discountAmount;

    const formattedOriginalPrice = this.formatPrice(originalPrice);
    const formattedDiscountedPrice = this.formatPrice(discountedPrice);

    const container = element.querySelector('.custom-discount__container');
    if (container) {
      container.innerHTML = `
        <div class="custom-discount__regular">
          <span class="custom-discount__original-price">
            De: <s>${formattedOriginalPrice}</s>
          </span>
          <span class="custom-discount__discounted-price">
            Por: ${formattedDiscountedPrice}
            ${discountLabel ? `<span class="custom-discount__label">${discountLabel}</span>` : ''}
            
            <span class="parcelado" style="margin-top: 3px;">
              ${this.generateInstallmentText(discountedPrice, true)}
            </span>
          </span>
        </div>
      `;
    }
  }

  /**
   * Atualiza configurações do desconto
   */
  updateSettings(newSettings) {
    this.discountSettings = { ...this.discountSettings, ...newSettings };
    this.updateAllPrices();
  }
}

// Inicializar apenas uma vez
if (!window.customDiscountManager) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.customDiscountManager = new CustomDiscountManager();
    });
  } else {
    // DOM já carregado
    window.customDiscountManager = new CustomDiscountManager();
  }
}

// Exportar para uso global
window.CustomDiscountManager = CustomDiscountManager;
